<template>
  <div>
    <div class="data-group-definition-form">
      <div class="modal-body">
        <base-input
          v-model="formItems.name"
          inputType="hiden"
          labelText="Yeni Veri Grubu Adı"
          :class="{ 'is-invalid': submitted && $v.formItems.name.$error }"
        />
        <div
          v-if="submitted && !$v.formItems.name.required"
          class="invalid-feedback"
        >
          {{ invalidMessage }}
        </div>
        <base-input
          v-model="formItems.shortContent"
          inputType="text"
          labelText="Kısa Tanım"
        />
      </div>
      <div class="modal-bottom">
        <base-button class="giveUp" @click="$modal.hide('modal')"
          >Vazgeç</base-button
        >
        <base-button @click="sendForm" class="add"> Kaydet </base-button>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { BaseInput, BaseButton } from "@/components";

export default {
  name: "DataGroupDefinitionForm",
  props: {
    clickedNewItemBtn: Boolean,
    id: Number,
    selectedDataId: Number,
    selectedDataName: String,
    selectedShortContent: String,
    selectedDataOrder: Number,
    shortContent: String,
    order: Number,
    InsertUpdateForm: {
      type: Function,
    },
  },
  data() {
    return {
      Template: "",
      defaultSelected: -1,
      invalidMessage: "Bu alan boş bırakılamaz!",
      formItems: {
        id: this.selectedDataId,
        name: this.selectedDataName,
        shortContent: this.selectedShortContent,
        order: Number(this.selectedDataOrder),
      },
      submitted: false,
    };
  },
  components: {
    BaseInput,
    BaseButton,
  },
  methods: {
    sendForm() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.clickedNewItemBtn) {
        delete this.formItems.id;
        delete this.formItems.order;
      }
      this.$emit("submit-form", this.formItems);
    },
  },
  validations: {
    formItems: {
      name: { required },
    },
  },
};
</script>
<style lang="scss">
.invalid-feedback {
  color: red;
  font-size: 12px;
  margin-top: 5px;
  padding-left: 10px;
}
.is-invalid {
  input {
    border: 1px solid red !important;
  }
}
</style>
